import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue';
import { FacetHit } from '@/composables/useDynamicProductListing';

import FacetValuesCheckboxItem from './FacetValuesCheckboxItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetValuesCheckbox',
  props: {
    facet: null
  },
  setup(__props: any) {

const props = __props as {
  facet: FacetHit;
}



const valuesSelectedOrWithProducts = computed(() => {
  return props.facet.values.filter(
    (f: any) =>
      f.count > 0 ||
      props.facet.selectedValues?.find((ff) => ff.value == f.value)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass([
      'facet-values-checkbox',
      {
        'facet-values-checkbox--two-columns': props.facet.id === 'Size',
      },
    ])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(valuesSelectedOrWithProducts), (value) => {
      return (_openBlock(), _createBlock(FacetValuesCheckboxItem, {
        key: value.value,
        facet: __props.facet,
        value: value
      }, null, 8, ["facet", "value"]))
    }), 128))
  ], 2))
}
}

})